module.exports = __webpack_public_path__ + "img/levelup-logo-blue.aa04b310.svg";